import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { providePrimeNG } from 'primeng/config';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor, sentryHttpInterceptor } from './core/interceptors';
import { JFX_PRESET } from 'src/theme/jfx-theme.preset';
import * as SentryAngular from '@sentry/angular';

export const APP_LANGS = {
  English: 'en',
  Dutch: 'nl',
} as const;

export const APP_LANG_STORAGE_KEY = 'appLang';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([sentryHttpInterceptor, authInterceptor])),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    provideIonicAngular(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
      fallbackLang: APP_LANGS.English,
      lang: localStorage.getItem(APP_LANG_STORAGE_KEY) ?? APP_LANGS.Dutch,
    }),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: JFX_PRESET,
        options: {
          darkModeSelector: false,
        },
      },
      pt: {
        card: {
          body: 'p-4!',
        },
      },
    }),
    { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler() },
  ],
};
